import React from 'react';
import type { Account, User } from '@citrite/sf-api';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';

const Context = React.createContext<AppContext>({
	piletApi: {
		Extension: () => null,
	} as any,
	user: {},
	account: {},
});

export interface AppContext {
	piletApi: PiletApi;
	user: User;
	account: Account;
	clearScrollCacheEventName?: string;
}

interface AppContextProviderProps {
	piletApi: PiletApi;
	children: React.ReactNode;
	clearScrollCacheEventName?: string;
}

export function getAccountRID(account: Account) {
	return `sharefile:account-${account.Id}`;
}

export const getUserRID = (account: Account, userId: string) => {
	return `${getAccountRID(account)}/user-${userId}`;
};

export function AppContextProvider(props: AppContextProviderProps) {
	return (
		<Context.Provider
			value={{
				piletApi: props.piletApi,
				...props.piletApi.sf.piletUserContext.get(),
				clearScrollCacheEventName: props.clearScrollCacheEventName,
			}}
		>
			{props.children}
		</Context.Provider>
	);
}

export const useAppContext = () => React.useContext(Context);
